// extracted by mini-css-extract-plugin
export default {"listWrapper":"SendPromo_listWrapper__08zza","eachRow":"SendPromo_eachRow__Cyka9","client_name":"SendPromo_client_name__2GCWM","phoneNumber":"SendPromo_phoneNumber__dxOdk"};